import React, { useContext } from 'react';
import { ThemeContext } from '../../utils/context';
import Badge from '../Badge';
import BadgeRow from '../BadgeRow';
import '../../i18n';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const isLight = theme === 'light';
  return (
    <footer
      role="contentinfo"
      aria-label="Site footer"
      className={`${isLight
        ? 'bg-[#f2f2f3] text-[#3d3d3d] border-t border-[#e1e1e1]'
        : 'bg-[#202020] text-[#d3d3d3] border-t border-[#2c2c2c]'
        } mt-16 w-full px-5 pt-10 pb-8 text-sm leading-relaxed transition-colors`}
    >
      <div
        className="grid gap-7 md:gap-8"
        style={{
          gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))',
          maxWidth: 1100,
          margin: '0 auto 25px',
        }}
      >
        <div className="flex flex-col gap-2.5">
          <div className="flex items-center gap-2 text-xl font-semibold">
            {/* <span
              className={`inline-block w-[34px] h-[34px] rounded-xl ${
                isLight ? 'shadow-sm' : 'shadow-md'
              } bg-gradient-to-br from-[#008cff] to-[#00b0ff] dark:from-[#1f6fb3] dark:to-[#008cff]`}
            /> */}
            <img src="/logo.png" alt="" className=' w-8 object-contain ' />
            <span className='tracking-tighter'> safaridew </span>
          </div>
          <p className="text-[13px] opacity-80 m-0">
            {t('imagination')} • {t('take_care')}
          </p>
          <p className="text-xs opacity-75 m-0">{t('we_work')}</p>
        </div>
        <div className="flex flex-col gap-2.5">
          <h4 className="text-[14px] font-semibold m-0">
            {t('services') || 'Services'}
          </h4>
          <BadgeRow>
            <Badge>UI / UX</Badge>
            <Badge>Web Apps</Badge>
            <Badge>Marketing</Badge>
            <Badge>AI / ChatGPT</Badge>
            <Badge>Branding</Badge>
          </BadgeRow>
        </div>
        <div className="flex flex-col gap-2.5">
          <h4 className="text-[14px] font-semibold m-0">
            {t("This app's stack") || 'Stack'}
          </h4>
          <BadgeRow>
            <Badge>React</Badge>
            <Badge>i18next</Badge>
            <Badge>Framer Motion</Badge>
            <Badge>TailwindCSS</Badge>
            <Badge>Styled</Badge>
          </BadgeRow>
        </div>

        {/* other */}
        <div className="flex flex-col gap-2.5">
          <h4 className="text-[14px] font-semibold m-0">
            {t('Other') || 'Info'}
          </h4>

          <p className="text-xs opacity-75 m-0">
            {t('lead')}: safaridew core team
          </p>
          <p className="text-xs opacity-75 m-0">
            {t('community')} & {t('marketing')}
          </p>
          <p className="text-xs opacity-75 m-0">{t('admin')}</p>
        </div>
      </div>

      {/* Separator */}
      <hr
        className={`${isLight ? 'bg-[#e6e6e6]' : 'bg-[#2c2c2c]'
          } h-px w-full border-0 my-5`}
      />
      <div className="max-w-[1100px] mx-auto flex flex-col gap-2 text-center text-[12px]">
        {/* Copyright */}
        <div className="flex flex-wrap items-center justify-center gap-2 mx-auto">
          <span className="flex items-center gap-1 opacity-70">
            <span className="text-base leading-none ">&copy;</span> 2023 safaridew
          </span>
          <span className="opacity-40 select-none">•</span>
          <span className="opacity-70">{t('copy')}</span>
        </div>
        <p className="text-[11px] opacity-55 m-0">
          Build: React • Accessibility first • No tracking cookies
        </p>
      </div>
    </footer>
  );
}

export default Footer;
